import type { $Fetch } from 'ofetch';
import type { WebhookDelivery, WebhookDeliveryStatus } from '@/domain/model/Webhook';
import type { Page } from '@/domain/model/Page';
import type { WebhookDeliveryGateway } from '@/application/port/out/WebhookDeliveryGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/webhooks/deliveries';

export class HttpWebhookDeliveryGateway implements WebhookDeliveryGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: { status?: WebhookDeliveryStatus; page?: number; size?: number }): Promise<Page<WebhookDelivery>> {
    const params: Record<string, string | number> = {};
    if (p.status) params['status'] = p.status;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<WebhookDelivery>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async get(id: string): Promise<WebhookDelivery> {
    const res = await this.client<ApiResponse<WebhookDelivery>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async replay(id: string): Promise<WebhookDelivery> {
    const res = await this.client<ApiResponse<WebhookDelivery>>(
      `${PATH}/${encodeURIComponent(id)}/replay`, { method: 'POST' },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
